import type { ButtonProps as ChakraButtonProps } from 'chakra-ui-next'
import { AbsoluteCenter, Button as ChakraButton, Span, Spinner } from 'chakra-ui-next'
import * as React from 'react'

interface ButtonLoadingProps {
  loading?: boolean
  loadingText?: React.ReactNode
  loadingElement?: React.ReactNode
}

export interface ButtonProps extends ChakraButtonProps, ButtonLoadingProps {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(props, ref) {
  const { loading, disabled, loadingText, loadingElement, children, ...rest } = props

  const renderLoadingElement = () => {
    return loadingElement ?? <Spinner size="inherit" color="inherit" />
  }

  return (
    <ChakraButton disabled={loading || disabled} ref={ref} {...rest}>
      {loading && !loadingText ? (
        <>
          <AbsoluteCenter display="inline-flex">{renderLoadingElement()}</AbsoluteCenter>
          <Span opacity={0}>{children}</Span>
        </>
      ) : loading && loadingText ? (
        <>
          {renderLoadingElement()}
          {loadingText}
        </>
      ) : (
        children
      )}
    </ChakraButton>
  )
})
